// extracted by mini-css-extract-plugin
export default {"content":"FullScreenPopup_content__v0DTn","header":"FullScreenPopup_header__Uf859","closeIcon":"FullScreenPopup_closeIcon__+mV5S"};